import { render, staticRenderFns } from "./taskDetailTable.vue?vue&type=template&id=f8b31d5c&scoped=true&"
import script from "./taskDetailTable.vue?vue&type=script&lang=js&"
export * from "./taskDetailTable.vue?vue&type=script&lang=js&"
import style0 from "./taskDetailTable.vue?vue&type=style&index=0&id=f8b31d5c&scoped=true&lang=css&"
import style1 from "./taskDetailTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8b31d5c",
  null
  
)

export default component.exports